var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoDeposit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crypto_deposit",
    transform: "translate(299 -8211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_acc",
    transform: "translate(-219 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-80 8128)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5624d39b35c645fcb2dc242597966b6",
    transform: "translate(-77.942 8130.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 60,
    height: 60,
    rx: 5.917,
    transform: "translate(-0.058 -0.058)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_5dd234bd551869460a6db0a677bf3c51",
    "data-name": "5dd234bd551869460a6db0a677bf3c51",
    transform: "translate(11.931 12.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24649",
    "data-name": "Path 24649",
    d: "M25.692,39.564H23.333a4.5,4.5,0,0,0,1.1-2.963.567.567,0,0,1,.384-.768c4.664-1.1,9.109-5.6,9.109-8.779v-2.14a.725.725,0,0,0-.713-.713H30.082a.534.534,0,0,1-.549-.439,7.043,7.043,0,0,0-2.689-5.323,3.5,3.5,0,0,1-.329-1.646,6.668,6.668,0,0,1,1.1-3.292A6.2,6.2,0,0,0,24.1,16.518a.552.552,0,0,1-.6.274c-.274-.055-.549-.11-.878-.165a5.853,5.853,0,0,1-1.1,2.085H22.4a.549.549,0,0,1,0,1.1H11.426a.549.549,0,1,1,0-1.1h.823a6.4,6.4,0,0,1-.933-1.536A10.744,10.744,0,0,0,4.292,27.218a8.936,8.936,0,0,0,4.884,8.011.552.552,0,0,1,.274.6A5.461,5.461,0,0,0,10.6,39.509H1.549a.549.549,0,1,0,0,1.1H14.718a.549.549,0,1,0,0-1.1H12.3a4.155,4.155,0,0,0,1.152-2.744A.59.59,0,0,1,14,36.217h5.816a.541.541,0,0,1,.549.494,4.513,4.513,0,0,0,1.207,2.8H16.913a.549.549,0,1,0,0,1.1h8.779a.59.59,0,0,0,.549-.549A.541.541,0,0,0,25.692,39.564Zm1.866-7.243a14.557,14.557,0,0,0,3.183-3.457.556.556,0,0,1,.933.6,15.556,15.556,0,0,1-3.4,3.731.549.549,0,0,1-.768-.11A.525.525,0,0,1,27.558,32.321ZM7.365,31.772a.508.508,0,0,1-.713-.219,8.155,8.155,0,0,1-1.207-5.816.56.56,0,0,1,1.1.219,8.837,8.837,0,0,0,1.043,5.158A.477.477,0,0,1,7.365,31.772Zm5.158-9.767a1.646,1.646,0,1,1-1.646,1.646A1.617,1.617,0,0,1,12.523,22.005Zm.439,10.755a.568.568,0,0,1-.768.055.533.533,0,0,1-.055-.768l8.779-9.877a.545.545,0,0,1,.823.713Zm8.34.219a1.646,1.646,0,1,1,1.646-1.646A1.617,1.617,0,0,1,21.3,32.979ZM3.195,27.437a10.813,10.813,0,0,1,.055-1.152A1.648,1.648,0,0,1,2.1,24.749a.59.59,0,0,0-.549-.549A.59.59,0,0,0,1,24.749,2.76,2.76,0,0,0,3.195,27.437Z",
    transform: "translate(0 -5.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24650",
    "data-name": "Path 24650",
    d: "M21.06,13.072h6.2a5,5,0,0,0,1.866-3.841,4.938,4.938,0,0,0-9.877,0A4.782,4.782,0,0,0,21.06,13.072Zm.384-6.585a.53.53,0,0,1,.768,0l.439.439a1.688,1.688,0,0,1,1.866.329.543.543,0,0,1-.768.768.543.543,0,1,0,0,.768,1.591,1.591,0,0,1,2.3,0,1.688,1.688,0,0,1,.329,1.866l.439.439a.543.543,0,0,1-.768.768l-.439-.439a1.688,1.688,0,0,1-1.866-.329.543.543,0,1,1,.768-.768.543.543,0,1,0,0-.768,1.591,1.591,0,0,1-2.3,0,1.688,1.688,0,0,1-.329-1.866l-.439-.439A.53.53,0,0,1,21.445,6.487ZM41.692,33.923H35.107a.549.549,0,0,0,0,1.1h6.585a.549.549,0,0,0,0-1.1ZM27.426,3.195a.518.518,0,0,0,.549-.549v-1.1a.549.549,0,1,0-1.1,0v1.1A.55.55,0,0,0,27.426,3.195Zm-5.487,0a.518.518,0,0,0,.549-.549v-1.1a.549.549,0,1,0-1.1,0v1.1A.55.55,0,0,0,21.938,3.195Zm8.779,3.292a.518.518,0,0,0,.549-.549V3.744a.549.549,0,1,0-1.1,0V5.938A.55.55,0,0,0,30.718,6.487Zm-13.169,0a.518.518,0,0,0,.549-.549V3.744a.549.549,0,0,0-1.1,0V5.938A.55.55,0,0,0,17.549,6.487Z",
    transform: "translate(-7.221)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoDeposit);
export default __webpack_public_path__ + "static/media/crypto_deposit.85366f974184014f55e78e1583b17045.svg";
export { ForwardRef as ReactComponent };